<div class="footer">
    <p>NICPETROL</p>
    <p>ARGENTINA - BUENOS AIRES</p>
</div>